module.exports = __webpack_public_path__ + "static/media/Vehicle.6bf5f95b.svg";